export const API_KEY = "3e0b2939-9c10-403f-95ed-db554510011f";

export const BASE_URL = "https://social-network.samuraijs.com/api/1.0/";